"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootViewController = void 0;
const ReactViewController_1 = require("./ReactViewController");
class RootViewController extends ReactViewController_1.ReactViewController {
    constructor(initElementFactory) {
        super({ element: typeof initElementFactory === 'function' ? initElementFactory() : null });
        this.createElement = (state) => {
            return state.element;
        };
    }
    replace(viewController) {
        this.setState({ element: viewController.render() });
    }
}
exports.RootViewController = RootViewController;
//# sourceMappingURL=RootViewController.js.map